import { useInfiniteQuery } from '@tanstack/react-query';

import backendForFrontend from '@clients/backendForFrontend';
import { Bucket } from '@clients/domains/delinquency/delinquencyBuckets';
// import notifyAPIError from '@utils/notifyAPIError';

const { getDelinquencies } = backendForFrontend();

interface UseGetDelinquencyOptions {
    accountId: number;
    onSuccess?: () => void;
    onError?: () => void;
    enabled?: boolean;
}
const useGetDelinquency = ({
    accountId,
    onSuccess,
    onError,
    enabled = true,
}: UseGetDelinquencyOptions) => {
    const {
        data: delinquencyData,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        isSuccess,
    } = useInfiniteQuery(
        ['getDelinquencies', { accountId }],
        ({ pageParam = 1 }: { pageParam?: number }) =>
            getDelinquencies({
                accountId,
                page: pageParam,
                perPage: 12,
            }),
        {
            getNextPageParam: (lastPage) => {
                return lastPage?.data?.search_delinquencies?.is_last_page
                    ? undefined
                    : lastPage?.data?.search_delinquencies?.current_page + 1;
            },
            onSuccess: onSuccess,
            onError: () => {
                // Removed as per UKFE-1174 - TODO - Add back in later
                // notifyAPIError(error);
                onError?.();
            },
            enabled,
        },
    );
    const flattenPages = delinquencyData?.pages?.flat(1);
    let data: Bucket[] = [];
    if (flattenPages) {
        data = flattenPages.reduce((previousValue, currentValue) => {
            if (currentValue?.data?.search_delinquencies?.items === null)
                return previousValue;
            return [
                ...previousValue,
                ...currentValue?.data?.search_delinquencies?.items,
            ];
        }, []);
    }
    return {
        data,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        isSuccess,
    };
};
export default useGetDelinquency;
